<template>
  <!-- eslint-disable max-len -->
  <span v-if="enabled">
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      style="enable-background:new 0 0 100 100;"
      xml:space="preserve"
    >
      <g>
        <path
          style="fill-rule:evenodd;clip-rule:evenodd;"
          d="M50,0c13.807,0,26.307,5.597,35.355,14.645C94.404,23.693,100,36.193,100,50
    s-5.596,26.307-14.645,35.355C76.307,94.403,63.807,100,50,100c-13.807,0-26.307-5.597-35.355-14.645C5.597,76.307,0,63.807,0,50
    s5.597-26.307,14.645-35.355C23.693,5.597,36.193,0,50,0L50,0z M43.52,63.69l0,0.018c0,2.88-1.167,5.488-3.055,7.376
    c-1.888,1.888-4.496,3.055-7.376,3.055c-2.88,0-5.488-1.168-7.376-3.055c-1.888-1.888-3.056-4.496-3.056-7.376
    s1.168-5.488,3.056-7.376c1.887-1.888,4.496-3.056,7.376-3.056c1.653,0,3.217,0.387,4.607,1.076V38.465
    c0-2.208,0.64-4.39,1.672-6.126c1.156-1.945,2.853-3.407,4.81-3.915l19.633-5.1c0.528-0.137,1.028-0.203,1.497-0.203
    c1.551,0,2.943,0.61,4.059,1.693c0.943,0.915,1.657,2.174,2.044,3.664c0.218,0.839,0.337,1.733,0.337,2.655v25.226l0,0.018
    c0,2.88-1.167,5.488-3.055,7.376c-1.888,1.888-4.496,3.055-7.376,3.055c-1.904,0-3.703-0.523-5.261-1.435
    c-1.603-0.938-2.931-2.286-3.835-3.895c-0.423-0.752-0.758-1.581-0.99-2.469c-0.225-0.863-0.345-1.746-0.345-2.631
    c0-2.88,1.168-5.488,3.056-7.376c1.887-1.888,4.496-3.056,7.376-3.056c1.653,0,3.217,0.387,4.607,1.076V31.132
    c0-0.468-0.047-0.87-0.132-1.199c-0.114-0.44-0.28-0.768-0.474-0.956c-0.021-0.021,0.006-0.032-0.01-0.032
    c-0.03,0-0.039-0.002-0.041-0.001l-19.633,5.1c-0.406,0.105-0.86,0.578-1.261,1.253c-0.526,0.885-0.853,2.013-0.853,3.168V63.69
    L43.52,63.69z"
        />
        <path
          style="fill-rule:evenodd;clip-rule:evenodd;"
          d="M33.08,59.076c2.544,0,4.607,2.063,4.607,4.607s-2.063,4.607-4.607,4.607
    c-2.544,0-4.607-2.063-4.607-4.607S30.535,59.076,33.08,59.076L33.08,59.076z"
        />
        <path
          style="fill-rule:evenodd;clip-rule:evenodd;"
          d="M61.323,51.768c2.544,0,4.607,2.063,4.607,4.607
    c0,2.544-2.063,4.607-4.607,4.607c-2.544,0-4.607-2.063-4.607-4.607C56.716,53.831,58.779,51.768,61.323,51.768L61.323,51.768z"
        />
      </g>
    </svg>
  </span>
  <span v-else>
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 107.087 107.087"
      style="enable-background:new 0 0 107.087 107.087;"
      xml:space="preserve"
    >
      <g>
        <path
          style="fill:none;stroke-width:7.0866;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256;"
          d="
    M53.543,3.543c27.614,0,50,22.386,50,50s-22.386,50-50,50c-27.614,0-50-22.386-50-50S25.929,3.543,53.543,3.543L53.543,3.543z
     M43.57,68.099V41.295c0-3.571,2.053-7.027,4.563-7.678l20.847-5.415c2.51-0.652,4.563,1.736,4.563,5.307v26.805 M35.586,60.115
    c4.41,0,7.984,3.575,7.984,7.984c0,4.41-3.575,7.984-7.984,7.984c-4.41,0-7.985-3.575-7.985-7.984
    C27.602,63.689,31.176,60.115,35.586,60.115L35.586,60.115z M65.56,52.329c4.41,0,7.984,3.575,7.984,7.984
    s-3.575,7.984-7.984,7.984c-4.41,0-7.985-3.575-7.985-7.984S61.15,52.329,65.56,52.329L65.56,52.329z M53.543,3.543
    c27.614,0,50,22.386,50,50s-22.386,50-50,50c-27.614,0-50-22.386-50-50S25.929,3.543,53.543,3.543L53.543,3.543z M43.57,68.099
    V41.295c0-3.571,2.053-7.027,4.563-7.678l20.847-5.415c2.51-0.652,4.563,1.736,4.563,5.307v26.805 M35.586,60.115
    c4.41,0,7.984,3.575,7.984,7.984c0,4.41-3.575,7.984-7.984,7.984c-4.41,0-7.985-3.575-7.985-7.984
    C27.602,63.689,31.176,60.115,35.586,60.115L35.586,60.115z M65.56,52.329c4.41,0,7.984,3.575,7.984,7.984
    s-3.575,7.984-7.984,7.984c-4.41,0-7.985-3.575-7.985-7.984S61.15,52.329,65.56,52.329L65.56,52.329z"
        />
      </g>
    </svg>
  </span>
</template>

<script>
export default {
  name: 'VolumeIcon',

  props: {
    enabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
